enum DrifterSupportedArchitecture {
  DARWIN_ARCH_64 = 'darwin-aarch64',
  DARWIN_X86_64 = 'darwin-x86_64',
  Linux = 'linux-x86_64',
  Windows = 'windows-x86_64',
}

enum DrifterSupportedDistribution {
  DMG = '.dmg',
  EXE = '.exe',
  MSI = '.msi',
  RPM = '.rpm',
  DEB = '.deb',
  APP_IMAGE = '.AppImage',
}

export { DrifterSupportedArchitecture, DrifterSupportedDistribution };
